var map = {
	"./主题.svg": "9209",
	"./关系语义.svg": "f1f9",
	"./功能映射.svg": "a387",
	"./属性语义.svg": "915f",
	"./形状映射.svg": "e681",
	"./情感.svg": "b463",
	"./数据.svg": "eab3",
	"./方位映射.svg": "4e16",
	"./物体语义.svg": "4640",
	"./状态映射.svg": "2621",
	"./结构映射.svg": "8ddf",
	"./轮廓映射.svg": "7580",
	"./过程映射.svg": "1269",
	"./领域语义.svg": "5044",
	"./颜色映射.svg": "6e88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96bc";